import styled from 'styled-components';
import Card from '../Card/Card';
import { finalViewsTypes } from '../themes/finalViewsTypes';
import { CardWrapper } from '../Card/Card.style';

const { SINGLENARROW } = finalViewsTypes;
export const CardWrapperOverride = styled(Card)`
    display: none;
    
    &:has(:not(:empty)) {
        display: inherit;
    }
`;

export const WrapWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    [data-mlb-test="controlled-overflow_outer-wrapper"] {
        padding-bottom: 0px;
    }
    ${({ $viewType }) => {
        if ($viewType === SINGLENARROW) {
            return `
                margin: 24px 0;
            `;
        }
    }}
`;

export const CarouselWrapper = styled(CardWrapper).attrs(({ $viewType }) => {
    if ($viewType === SINGLENARROW) {
        return { $displayFlat: true };
    }
})`
    display: none;
    
    &:has(:not(:empty)) {
        display: inherit;
    }

    ${({ $viewType, $marginOverride }) => {
        if ($viewType === SINGLENARROW) {
            return `
                margin: ${$marginOverride || '0 0 0 0'};
                
            `;
        }
    }};

    
`;

export const FinalCardWrapper = styled(CardWrapper).attrs(({ $viewType }) => {
    if ($viewType === SINGLENARROW) {
        return { $displayFlat: true };
    }
})`
    
    display: none;
    
    &:has(:not(:empty)) {
        display: inherit;
    }

    ${({ $viewType }) => {
        if ($viewType === SINGLENARROW) {
            return `
                margin: 24px var(--gameday-section-margin-sm) 0 var(--gameday-section-margin-sm);
            `;
        }
    }};
    
`;
